import { render, staticRenderFns } from "./AddNoteDialog.vue?vue&type=template&id=5364aeea"
import script from "./AddNoteDialog.vue?vue&type=script&lang=ts"
export * from "./AddNoteDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddNoteDialog.vue?vue&type=style&index=0&id=5364aeea&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports